import firebase from 'firebase/app'
import moment from 'moment'
import { isEmpty } from '@/api/utils'
import { VISITOR } from '@/api/constants'

let visitorRef, visitorCountRef, visitorLastTimeRef, visitorSessionSecRef
const visitorFirebaseApi = {
  fetchVisitor (userParsedEmail, buildingId) {
    // console.log('FetchVisitor')
    const basicRef = `${VISITOR.BASIC_FOLDER}/${buildingId}/${VISITOR.USER}/${userParsedEmail}`
    visitorRef = firebase.database().ref(`${basicRef}`)
    visitorCountRef = firebase.database().ref(`${basicRef}/${VISITOR.VIEW_COUNT}`)
    visitorLastTimeRef = firebase.database().ref(`${basicRef}/${VISITOR.VIEW_LAST_TIME}`)
    visitorSessionSecRef = firebase.database().ref(`${basicRef}/${VISITOR.VIEW_SESSION_SEC}`)

    visitorRef.once('value', snapshot => {
      const visitor = snapshot.val() || {}
      if (!isEmpty(visitor) && visitor.activated) {
        this.updateVisitorViewCount()
        this.updateVisitorViewLastTime()
        this.startRecordVisitorViewSessionSec()
      }
    })
  },
  updateVisitorViewCount () {
    // console.log('Update Visitor View Count')
    if (visitorCountRef) {
      visitorCountRef.transaction(viewCount => {
        return ++viewCount
      })
    }
  },
  updateVisitorViewLastTime () {
    // console.log('Update Visitor View Last Time')
    if (visitorLastTimeRef) {
      visitorLastTimeRef.transaction(viewLastTime => {
        return moment().format()
      })
    }
  },
  updateVisitorViewSessionSec (intervalMS) {
    // console.log('Update Visitor View Session Sec')
    if (visitorSessionSecRef) {
      visitorSessionSecRef.transaction(viewSessionSec => {
        return viewSessionSec + intervalMS / 1000
      })
    }
  },
  startRecordVisitorViewSessionSec () {
    // console.log('Start Record Visitor View Session')
    const intervalMS = 5000
    const repeat = () => {
      this.updateVisitorViewLastTime()
      this.updateVisitorViewSessionSec(intervalMS)
      window.setTimeout(repeat, intervalMS)
    }
    window.setTimeout(repeat, intervalMS)
  }
}

export default visitorFirebaseApi
